export type Json = string | number | boolean | null | { [key: string]: Json | undefined } | Json[]

export type Database = {
  graphql_public: {
    Tables: {
      [_ in never]: never
    }
    Views: {
      [_ in never]: never
    }
    Functions: {
      graphql: {
        Args: { extensions?: Json; operationName?: string; query?: string; variables?: Json }
        Returns: Json
      }
    }
    Enums: {
      [_ in never]: never
    }
    CompositeTypes: {
      [_ in never]: never
    }
  }
  public: {
    Tables: {
      action_costs: {
        Row: {
          cost: number
          created_at: string | null
          id: string
          job_id: string | null
          type: string
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          cost: number
          created_at?: string | null
          id?: string
          job_id?: string | null
          type: string
          updated_at?: string | null
        }
        Update: {
          cost?: number
          created_at?: string | null
          id?: string
          job_id?: string | null
          type?: string
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "action_costs_job_id_fkey"
            columns: ["job_id"]
            isOneToOne: false
            referencedRelation: "jobs"
            referencedColumns: ["id"]
          },
        ]
      }
      activity_logs: {
        Row: {
          action: string
          actor_email: string | null
          actor_name: string | null
          actor_role: string | null
          actor_user_id: string | null
          after: Json | null
          before: Json | null
          created_at: string
          entity: string
          entity_id: string | null
          error: string | null
          id: string
          success: boolean
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          action: string
          actor_email?: string | null
          actor_name?: string | null
          actor_role?: string | null
          actor_user_id?: string | null
          after?: Json | null
          before?: Json | null
          created_at?: string
          entity: string
          entity_id?: string | null
          error?: string | null
          id?: string
          success?: boolean
          updated_at?: string | null
        }
        Update: {
          action?: string
          actor_email?: string | null
          actor_name?: string | null
          actor_role?: string | null
          actor_user_id?: string | null
          after?: Json | null
          before?: Json | null
          created_at?: string
          entity?: string
          entity_id?: string | null
          error?: string | null
          id?: string
          success?: boolean
          updated_at?: string | null
        }
        Relationships: []
      }
      amendments: {
        Row: {
          amendment_id: string
          amount: number | null
          created_at: string | null
          date: string | null
          details: string | null
          external_id: string | null
          id: string
          people_id: string | null
          person_id: string | null
          type: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          amendment_id: string
          amount?: number | null
          created_at?: string | null
          date?: string | null
          details?: string | null
          external_id?: string | null
          id?: string
          people_id?: string | null
          person_id?: string | null
          type?: string | null
          updated_at?: string | null
        }
        Update: {
          amendment_id?: string
          amount?: number | null
          created_at?: string | null
          date?: string | null
          details?: string | null
          external_id?: string | null
          id?: string
          people_id?: string | null
          person_id?: string | null
          type?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "amendments_people_id_fkey"
            columns: ["people_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
        ]
      }
      anonymous_visitors: {
        Row: {
          completed_form: boolean | null
          completed_form_at: string | null
          created_at: string | null
          id: string
          job_id: string | null
          source: string | null
          started_form: boolean | null
          started_form_at: string | null
          updated_at: string | null
          visited_at: string
        }
        ComputedFields: never
        Insert: {
          completed_form?: boolean | null
          completed_form_at?: string | null
          created_at?: string | null
          id?: string
          job_id?: string | null
          source?: string | null
          started_form?: boolean | null
          started_form_at?: string | null
          updated_at?: string | null
          visited_at?: string
        }
        Update: {
          completed_form?: boolean | null
          completed_form_at?: string | null
          created_at?: string | null
          id?: string
          job_id?: string | null
          source?: string | null
          started_form?: boolean | null
          started_form_at?: string | null
          updated_at?: string | null
          visited_at?: string
        }
        Relationships: []
      }
      api_keys: {
        Row: {
          created_at: string | null
          description: string | null
          expires_at: string | null
          id: string
          key_hash: string
          revoked: boolean
          role: Database["public"]["Enums"]["app_role"]
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          created_at?: string | null
          description?: string | null
          expires_at?: string | null
          id?: string
          key_hash: string
          revoked?: boolean
          role: Database["public"]["Enums"]["app_role"]
          updated_at?: string | null
        }
        Update: {
          created_at?: string | null
          description?: string | null
          expires_at?: string | null
          id?: string
          key_hash?: string
          revoked?: boolean
          role?: Database["public"]["Enums"]["app_role"]
          updated_at?: string | null
        }
        Relationships: []
      }
      applicants: {
        Row: {
          account_holder_name: string | null
          account_number: string | null
          address_line_1: string | null
          address_line_2: string | null
          application_id: string | null
          availability_days: string[] | null
          availability_days_count: string | null
          bank_name: string | null
          city: string | null
          company_number: string | null
          company_type: string | null
          cpc_number: string | null
          created_at: string | null
          date_of_birth: string | null
          driving_licence_number: string | null
          driving_licence_number_verified_via_api: boolean
          eligibility_dvla: boolean | null
          eligibility_rtw: boolean | null
          email: string | null
          first_name: string | null
          has_electric_van: boolean | null
          id: string
          insurance_provider: string | null
          last_name: string | null
          needs_rental_van: boolean | null
          next_of_kin_name: string | null
          next_of_kin_phone: string | null
          next_of_kin_relation: string | null
          ni_number: string | null
          phone_number: string | null
          policy_number: string | null
          postcode: string | null
          sex: Database["public"]["Enums"]["sex_enum"] | null
          share_code_rtw: string | null
          share_code_rtw_verified_via_api: boolean
          sort_code: string | null
          tachograph_card_number: string | null
          updated_at: string | null
          utr_number: string | null
          vat_number: string | null
        }
        ComputedFields: never
        Insert: {
          account_holder_name?: string | null
          account_number?: string | null
          address_line_1?: string | null
          address_line_2?: string | null
          application_id?: string | null
          availability_days?: string[] | null
          availability_days_count?: string | null
          bank_name?: string | null
          city?: string | null
          company_number?: string | null
          company_type?: string | null
          cpc_number?: string | null
          created_at?: string | null
          date_of_birth?: string | null
          driving_licence_number?: string | null
          driving_licence_number_verified_via_api?: boolean
          eligibility_dvla?: boolean | null
          eligibility_rtw?: boolean | null
          email?: string | null
          first_name?: string | null
          has_electric_van?: boolean | null
          id?: string
          insurance_provider?: string | null
          last_name?: string | null
          needs_rental_van?: boolean | null
          next_of_kin_name?: string | null
          next_of_kin_phone?: string | null
          next_of_kin_relation?: string | null
          ni_number?: string | null
          phone_number?: string | null
          policy_number?: string | null
          postcode?: string | null
          sex?: Database["public"]["Enums"]["sex_enum"] | null
          share_code_rtw?: string | null
          share_code_rtw_verified_via_api?: boolean
          sort_code?: string | null
          tachograph_card_number?: string | null
          updated_at?: string | null
          utr_number?: string | null
          vat_number?: string | null
        }
        Update: {
          account_holder_name?: string | null
          account_number?: string | null
          address_line_1?: string | null
          address_line_2?: string | null
          application_id?: string | null
          availability_days?: string[] | null
          availability_days_count?: string | null
          bank_name?: string | null
          city?: string | null
          company_number?: string | null
          company_type?: string | null
          cpc_number?: string | null
          created_at?: string | null
          date_of_birth?: string | null
          driving_licence_number?: string | null
          driving_licence_number_verified_via_api?: boolean
          eligibility_dvla?: boolean | null
          eligibility_rtw?: boolean | null
          email?: string | null
          first_name?: string | null
          has_electric_van?: boolean | null
          id?: string
          insurance_provider?: string | null
          last_name?: string | null
          needs_rental_van?: boolean | null
          next_of_kin_name?: string | null
          next_of_kin_phone?: string | null
          next_of_kin_relation?: string | null
          ni_number?: string | null
          phone_number?: string | null
          policy_number?: string | null
          postcode?: string | null
          sex?: Database["public"]["Enums"]["sex_enum"] | null
          share_code_rtw?: string | null
          share_code_rtw_verified_via_api?: boolean
          sort_code?: string | null
          tachograph_card_number?: string | null
          updated_at?: string | null
          utr_number?: string | null
          vat_number?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "applicants_application_id_fkey"
            columns: ["application_id"]
            isOneToOne: false
            referencedRelation: "applications"
            referencedColumns: ["id"]
          },
        ]
      }
      application_stage_history: {
        Row: {
          application_id: string
          created_at: string | null
          id: string
          moved_at: string
          stage: string
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          application_id: string
          created_at?: string | null
          id?: string
          moved_at?: string
          stage: string
          updated_at?: string | null
        }
        Update: {
          application_id?: string
          created_at?: string | null
          id?: string
          moved_at?: string
          stage?: string
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "stage_history_application_id_fkey"
            columns: ["application_id"]
            isOneToOne: false
            referencedRelation: "applications"
            referencedColumns: ["id"]
          },
        ]
      }
      applications: {
        Row: {
          applicant_id: string | null
          application_id: string | null
          changed_stage_at: string | null
          contract_salary: number | null
          created_at: string | null
          current_segment: string | null
          current_stage: string | null
          driver_manager_team: string | null
          driver_manager_team_id: string | null
          dsp: string | null
          dsp_id: string | null
          dvla_consent_accepted_at: string | null
          id: string
          job_id: string | null
          last_communication: string | null
          last_edited_by: string | null
          person_id: string | null
          primary_person_id: string | null
          ref_driver_id: string | null
          stage_note: string | null
          stage_reason: string | null
          status: string | null
          updated_at: string | null
          user_id: string
          vehicle_booking: Json | null
        }
        ComputedFields: never
        Insert: {
          applicant_id?: string | null
          application_id?: string | null
          changed_stage_at?: string | null
          contract_salary?: number | null
          created_at?: string | null
          current_segment?: string | null
          current_stage?: string | null
          driver_manager_team?: string | null
          driver_manager_team_id?: string | null
          dsp?: string | null
          dsp_id?: string | null
          dvla_consent_accepted_at?: string | null
          id?: string
          job_id?: string | null
          last_communication?: string | null
          last_edited_by?: string | null
          person_id?: string | null
          primary_person_id?: string | null
          ref_driver_id?: string | null
          stage_note?: string | null
          stage_reason?: string | null
          status?: string | null
          updated_at?: string | null
          user_id: string
          vehicle_booking?: Json | null
        }
        Update: {
          applicant_id?: string | null
          application_id?: string | null
          changed_stage_at?: string | null
          contract_salary?: number | null
          created_at?: string | null
          current_segment?: string | null
          current_stage?: string | null
          driver_manager_team?: string | null
          driver_manager_team_id?: string | null
          dsp?: string | null
          dsp_id?: string | null
          dvla_consent_accepted_at?: string | null
          id?: string
          job_id?: string | null
          last_communication?: string | null
          last_edited_by?: string | null
          person_id?: string | null
          primary_person_id?: string | null
          ref_driver_id?: string | null
          stage_note?: string | null
          stage_reason?: string | null
          status?: string | null
          updated_at?: string | null
          user_id?: string
          vehicle_booking?: Json | null
        }
        Relationships: [
          {
            foreignKeyName: "applications_applicant_id_fkey"
            columns: ["applicant_id"]
            isOneToOne: false
            referencedRelation: "applicants"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "applications_job_id_fkey"
            columns: ["job_id"]
            isOneToOne: false
            referencedRelation: "jobs"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "applications_person_id_fkey"
            columns: ["person_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "applications_primary_person_id_fkey"
            columns: ["primary_person_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "applications_ref_driver_id_fkey"
            columns: ["ref_driver_id"]
            isOneToOne: false
            referencedRelation: "applications"
            referencedColumns: ["id"]
          },
        ]
      }
      assessments: {
        Row: {
          application_id: string | null
          completed_at: string | null
          created_at: string | null
          id: string
          question_num: number
          result: string | null
          result_breakdown: Json | null
          score: number | null
          started_at: string | null
          type: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          application_id?: string | null
          completed_at?: string | null
          created_at?: string | null
          id?: string
          question_num?: number
          result?: string | null
          result_breakdown?: Json | null
          score?: number | null
          started_at?: string | null
          type?: string | null
          updated_at?: string | null
        }
        Update: {
          application_id?: string | null
          completed_at?: string | null
          created_at?: string | null
          id?: string
          question_num?: number
          result?: string | null
          result_breakdown?: Json | null
          score?: number | null
          started_at?: string | null
          type?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "assessments_application_id_fkey"
            columns: ["application_id"]
            isOneToOne: false
            referencedRelation: "applications"
            referencedColumns: ["id"]
          },
        ]
      }
      audit_logs: {
        Row: {
          action: string
          actor: string | null
          actor_kind: string
          actor_user_id: string | null
          changes: NonNullable<Json>
          comment: string | null
          created_at: string
          id: string
          record_id: string
          table_name: string
        }
        ComputedFields: never
        Insert: {
          action: string
          actor?: string | null
          actor_kind?: string
          actor_user_id?: string | null
          changes: NonNullable<Json>
          comment?: string | null
          created_at?: string
          id?: string
          record_id: string
          table_name: string
        }
        Update: {
          action?: string
          actor?: string | null
          actor_kind?: string
          actor_user_id?: string | null
          changes?: NonNullable<Json>
          comment?: string | null
          created_at?: string
          id?: string
          record_id?: string
          table_name?: string
        }
        Relationships: [
          {
            foreignKeyName: "audit_logs_actor_user_id_fkey"
            columns: ["actor_user_id"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      auth_session_cache: {
        Row: {
          access_token: string
          cognito_sub: string | null
          created_at: string
          email: string | null
          expires_at: string
          id: string
          refresh_token: string | null
          supabase_user_id: string
          updated_at: string
        }
        ComputedFields: never
        Insert: {
          access_token: string
          cognito_sub?: string | null
          created_at?: string
          email?: string | null
          expires_at: string
          id?: string
          refresh_token?: string | null
          supabase_user_id: string
          updated_at?: string
        }
        Update: {
          access_token?: string
          cognito_sub?: string | null
          created_at?: string
          email?: string | null
          expires_at?: string
          id?: string
          refresh_token?: string | null
          supabase_user_id?: string
          updated_at?: string
        }
        Relationships: []
      }
      car_parks: {
        Row: {
          address: string | null
          city: string | null
          created_at: string
          deleted_at: string | null
          depot_id: string
          geofence_radius_meters: number
          id: string
          latitude: number
          longitude: number
          name: string
          updated_at: string
          zerity_id: number | null
        }
        ComputedFields: never
        Insert: {
          address?: string | null
          city?: string | null
          created_at?: string
          deleted_at?: string | null
          depot_id: string
          geofence_radius_meters: number
          id?: string
          latitude: number
          longitude: number
          name: string
          updated_at?: string
          zerity_id?: number | null
        }
        Update: {
          address?: string | null
          city?: string | null
          created_at?: string
          deleted_at?: string | null
          depot_id?: string
          geofence_radius_meters?: number
          id?: string
          latitude?: number
          longitude?: number
          name?: string
          updated_at?: string
          zerity_id?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "car_parks_depot_id_fkey"
            columns: ["depot_id"]
            isOneToOne: false
            referencedRelation: "depots"
            referencedColumns: ["id"]
          },
        ]
      }
      comments: {
        Row: {
          application_id: string | null
          comment: string | null
          created_at: string | null
          id: string
          updated_at: string | null
          user_id: string
        }
        ComputedFields: never
        Insert: {
          application_id?: string | null
          comment?: string | null
          created_at?: string | null
          id?: string
          updated_at?: string | null
          user_id?: string
        }
        Update: {
          application_id?: string | null
          comment?: string | null
          created_at?: string | null
          id?: string
          updated_at?: string | null
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "comments_application_id_fkey"
            columns: ["application_id"]
            isOneToOne: false
            referencedRelation: "applications"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "comments_user_id_fkey"
            columns: ["user_id"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      conduct: {
        Row: {
          conduct_id: string
          created_at: string | null
          date: string | null
          details: string | null
          external_id: string | null
          id: string
          people_id: string | null
          person_id: string | null
          severity: number | null
          type: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          conduct_id: string
          created_at?: string | null
          date?: string | null
          details?: string | null
          external_id?: string | null
          id?: string
          people_id?: string | null
          person_id?: string | null
          severity?: number | null
          type?: string | null
          updated_at?: string | null
        }
        Update: {
          conduct_id?: string
          created_at?: string | null
          date?: string | null
          details?: string | null
          external_id?: string | null
          id?: string
          people_id?: string | null
          person_id?: string | null
          severity?: number | null
          type?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "conduct_people_id_fkey"
            columns: ["people_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
        ]
      }
      cron_migrations: {
        Row: {
          created_at: string
          details: Json | null
          id: string
          migrated_at: string | null
          table: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          created_at?: string
          details?: Json | null
          id?: string
          migrated_at?: string | null
          table?: string | null
          updated_at?: string | null
        }
        Update: {
          created_at?: string
          details?: Json | null
          id?: string
          migrated_at?: string | null
          table?: string | null
          updated_at?: string | null
        }
        Relationships: []
      }
      depots: {
        Row: {
          address: string | null
          city: string | null
          created_at: string | null
          depot_id: string | null
          geofence_radius_meters: number
          id: string
          latitude: number | null
          longitude: number | null
          name: string | null
          updated_at: string | null
          valid_from: string
          valid_until: string | null
          zerity_id: number | null
        }
        ComputedFields: never
        Insert: {
          address?: string | null
          city?: string | null
          created_at?: string | null
          depot_id?: string | null
          geofence_radius_meters?: number
          id?: string
          latitude?: number | null
          longitude?: number | null
          name?: string | null
          updated_at?: string | null
          valid_from?: string
          valid_until?: string | null
          zerity_id?: number | null
        }
        Update: {
          address?: string | null
          city?: string | null
          created_at?: string | null
          depot_id?: string | null
          geofence_radius_meters?: number
          id?: string
          latitude?: number | null
          longitude?: number | null
          name?: string | null
          updated_at?: string | null
          valid_from?: string
          valid_until?: string | null
          zerity_id?: number | null
        }
        Relationships: []
      }
      diary_entries: {
        Row: {
          action_completed: boolean | null
          call_date_time: string | null
          conducted_by_email: string | null
          created_at: string | null
          driver_manager_team: string | null
          employer: string | null
          engagement_sub_tag: string | null
          engagement_tag: string | null
          entry_id: string | null
          follow_up_action: string | null
          id: string
          location: string[] | null
          notes: string | null
          people_id: string | null
          sheriff_areas: string[] | null
          sheriff_type: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          action_completed?: boolean | null
          call_date_time?: string | null
          conducted_by_email?: string | null
          created_at?: string | null
          driver_manager_team?: string | null
          employer?: string | null
          engagement_sub_tag?: string | null
          engagement_tag?: string | null
          entry_id?: string | null
          follow_up_action?: string | null
          id?: string
          location?: string[] | null
          notes?: string | null
          people_id?: string | null
          sheriff_areas?: string[] | null
          sheriff_type?: string | null
          updated_at?: string | null
        }
        Update: {
          action_completed?: boolean | null
          call_date_time?: string | null
          conducted_by_email?: string | null
          created_at?: string | null
          driver_manager_team?: string | null
          employer?: string | null
          engagement_sub_tag?: string | null
          engagement_tag?: string | null
          entry_id?: string | null
          follow_up_action?: string | null
          id?: string
          location?: string[] | null
          notes?: string | null
          people_id?: string | null
          sheriff_areas?: string[] | null
          sheriff_type?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "diary_entries_people_id_fkey"
            columns: ["people_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
        ]
      }
      documents: {
        Row: {
          application_id: string | null
          created_at: string | null
          file: string | null
          id: string
          person_id: string | null
          status: string | null
          type: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          application_id?: string | null
          created_at?: string | null
          file?: string | null
          id?: string
          person_id?: string | null
          status?: string | null
          type?: string | null
          updated_at?: string | null
        }
        Update: {
          application_id?: string | null
          created_at?: string | null
          file?: string | null
          id?: string
          person_id?: string | null
          status?: string | null
          type?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "documents_application_id_fkey"
            columns: ["application_id"]
            isOneToOne: false
            referencedRelation: "applications"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "documents_person_id_fkey"
            columns: ["person_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
        ]
      }
      driver_dvla_checks: {
        Row: {
          application_id: string | null
          cpc_lgv_expiry: string | null
          cpc_national: boolean | null
          cpc_pcv_expiry: string | null
          created_at: string | null
          driving_licence_expiry: string | null
          driving_licence_number: string
          driving_licence_status: string | null
          driving_licence_valid_from: string | null
          id: string
          tacho_card_number: string | null
          tacho_expiry: string | null
          tacho_status: string | null
          tacho_valid_from: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          application_id?: string | null
          cpc_lgv_expiry?: string | null
          cpc_national?: boolean | null
          cpc_pcv_expiry?: string | null
          created_at?: string | null
          driving_licence_expiry?: string | null
          driving_licence_number: string
          driving_licence_status?: string | null
          driving_licence_valid_from?: string | null
          id?: string
          tacho_card_number?: string | null
          tacho_expiry?: string | null
          tacho_status?: string | null
          tacho_valid_from?: string | null
          updated_at?: string | null
        }
        Update: {
          application_id?: string | null
          cpc_lgv_expiry?: string | null
          cpc_national?: boolean | null
          cpc_pcv_expiry?: string | null
          created_at?: string | null
          driving_licence_expiry?: string | null
          driving_licence_number?: string
          driving_licence_status?: string | null
          driving_licence_valid_from?: string | null
          id?: string
          tacho_card_number?: string | null
          tacho_expiry?: string | null
          tacho_status?: string | null
          tacho_valid_from?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "documents_application_id_fkey"
            columns: ["application_id"]
            isOneToOne: false
            referencedRelation: "applications"
            referencedColumns: ["id"]
          },
        ]
      }
      driver_licence_records: {
        Row: {
          address_line1: string | null
          address_line2: string | null
          address_line5: string | null
          application_id: string | null
          cpc: Json | null
          created_at: string | null
          date_of_birth: string | null
          driving_licence_number: string | null
          eligible: boolean | null
          endorsements: Json | null
          entitlement: Json | null
          first_name: string | null
          gender: string | null
          holder: Json | null
          id: string
          last_name: string | null
          licence_status: string | null
          licence_type: string | null
          people_id: string | null
          postcode: string | null
          token_issue_number: string | null
          token_valid_from: string | null
          token_valid_to: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          address_line1?: string | null
          address_line2?: string | null
          address_line5?: string | null
          application_id?: string | null
          cpc?: Json | null
          created_at?: string | null
          date_of_birth?: string | null
          driving_licence_number?: string | null
          eligible?: boolean | null
          endorsements?: Json | null
          entitlement?: Json | null
          first_name?: string | null
          gender?: string | null
          holder?: Json | null
          id?: string
          last_name?: string | null
          licence_status?: string | null
          licence_type?: string | null
          people_id?: string | null
          postcode?: string | null
          token_issue_number?: string | null
          token_valid_from?: string | null
          token_valid_to?: string | null
          updated_at?: string | null
        }
        Update: {
          address_line1?: string | null
          address_line2?: string | null
          address_line5?: string | null
          application_id?: string | null
          cpc?: Json | null
          created_at?: string | null
          date_of_birth?: string | null
          driving_licence_number?: string | null
          eligible?: boolean | null
          endorsements?: Json | null
          entitlement?: Json | null
          first_name?: string | null
          gender?: string | null
          holder?: Json | null
          id?: string
          last_name?: string | null
          licence_status?: string | null
          licence_type?: string | null
          people_id?: string | null
          postcode?: string | null
          token_issue_number?: string | null
          token_valid_from?: string | null
          token_valid_to?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "driver_licence_records_application_id_fkey"
            columns: ["application_id"]
            isOneToOne: false
            referencedRelation: "applications"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "driver_licence_records_people_id_fkey"
            columns: ["people_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
        ]
      }
      driver_manager_teams: {
        Row: {
          active: boolean
          airtable_record_id: string | null
          created_at: string
          id: string
          name: string | null
          team: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          active?: boolean
          airtable_record_id?: string | null
          created_at?: string
          id?: string
          name?: string | null
          team?: string | null
          updated_at?: string | null
        }
        Update: {
          active?: boolean
          airtable_record_id?: string | null
          created_at?: string
          id?: string
          name?: string | null
          team?: string | null
          updated_at?: string | null
        }
        Relationships: []
      }
      driver_notifications: {
        Row: {
          body: string
          channel: string
          created_at: string
          data: Json | null
          notification_id: string
          notification_type: string
          opened_at: string | null
          people_id: string
          shift_id: string | null
          status: string
          title: string
          updated_at: string
        }
        ComputedFields: never
        Insert: {
          body: string
          channel: string
          created_at?: string
          data?: Json | null
          notification_id?: string
          notification_type: string
          opened_at?: string | null
          people_id: string
          shift_id?: string | null
          status?: string
          title: string
          updated_at?: string
        }
        Update: {
          body?: string
          channel?: string
          created_at?: string
          data?: Json | null
          notification_id?: string
          notification_type?: string
          opened_at?: string | null
          people_id?: string
          shift_id?: string | null
          status?: string
          title?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "driver_notifications_people_id_fkey"
            columns: ["people_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "driver_notifications_shift_id_fkey"
            columns: ["shift_id"]
            isOneToOne: false
            referencedRelation: "shifts"
            referencedColumns: ["id"]
          },
        ]
      }
      dsps: {
        Row: {
          active: boolean
          airtable_record_id: string | null
          created_at: string
          dsp: string | null
          id: string
          legal_name: string | null
          notes: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          active?: boolean
          airtable_record_id?: string | null
          created_at?: string
          dsp?: string | null
          id?: string
          legal_name?: string | null
          notes?: string | null
          updated_at?: string | null
        }
        Update: {
          active?: boolean
          airtable_record_id?: string | null
          created_at?: string
          dsp?: string | null
          id?: string
          legal_name?: string | null
          notes?: string | null
          updated_at?: string | null
        }
        Relationships: []
      }
      feature_flags: {
        Row: {
          admin_enabled: boolean | null
          created_at: string | null
          description: string | null
          driver_enabled: boolean | null
          dsp_enabled: boolean | null
          enabled: boolean | null
          feature_key: string
          feature_name: string
          id: string
          manager_enabled: boolean | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          admin_enabled?: boolean | null
          created_at?: string | null
          description?: string | null
          driver_enabled?: boolean | null
          dsp_enabled?: boolean | null
          enabled?: boolean | null
          feature_key: string
          feature_name: string
          id?: string
          manager_enabled?: boolean | null
          updated_at?: string | null
        }
        Update: {
          admin_enabled?: boolean | null
          created_at?: string | null
          description?: string | null
          driver_enabled?: boolean | null
          dsp_enabled?: boolean | null
          enabled?: boolean | null
          feature_key?: string
          feature_name?: string
          id?: string
          manager_enabled?: boolean | null
          updated_at?: string | null
        }
        Relationships: []
      }
      incentive_runs: {
        Row: {
          error: string | null
          finished_at: string | null
          id: string
          result: Json | null
          started_at: string
          status: string
        }
        ComputedFields: never
        Insert: {
          error?: string | null
          finished_at?: string | null
          id?: string
          result?: Json | null
          started_at?: string
          status?: string
        }
        Update: {
          error?: string | null
          finished_at?: string | null
          id?: string
          result?: Json | null
          started_at?: string
          status?: string
        }
        Relationships: []
      }
      incentive_tickets: {
        Row: {
          amount: number
          count: number
          error: string | null
          id: string
          incentive_id: string
          people_id: string
          period_end: string
          period_start: string
          raised_at: string
          raised_by: string | null
          route_codes: string[]
          status: string
          ticket_id: string
        }
        ComputedFields: never
        Insert: {
          amount: number
          count: number
          error?: string | null
          id?: string
          incentive_id: string
          people_id: string
          period_end: string
          period_start: string
          raised_at?: string
          raised_by?: string | null
          route_codes?: string[]
          status: string
          ticket_id: string
        }
        Update: {
          amount?: number
          count?: number
          error?: string | null
          id?: string
          incentive_id?: string
          people_id?: string
          period_end?: string
          period_start?: string
          raised_at?: string
          raised_by?: string | null
          route_codes?: string[]
          status?: string
          ticket_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "incentive_tickets_incentive_id_fkey"
            columns: ["incentive_id"]
            isOneToOne: false
            referencedRelation: "incentives"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "incentive_tickets_people_id_fkey"
            columns: ["people_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
        ]
      }
      incentives: {
        Row: {
          amount: number
          app_comms: Json | null
          app_comms_updated_at: string | null
          audiences: NonNullable<Json>
          created_at: string
          created_by: string | null
          end_date: string | null
          id: string
          name: string
          one_route_per_day: boolean
          pay_description: string
          period: string
          route_cycles: string[]
          route_types: string[]
          start_date: string
          status: string
          threshold: number | null
          unit: string
          updated_at: string
        }
        ComputedFields: never
        Insert: {
          amount: number
          app_comms?: Json | null
          app_comms_updated_at?: string | null
          audiences?: NonNullable<Json>
          created_at?: string
          created_by?: string | null
          end_date?: string | null
          id?: string
          name: string
          one_route_per_day?: boolean
          pay_description: string
          period?: string
          route_cycles: string[]
          route_types: string[]
          start_date: string
          status?: string
          threshold?: number | null
          unit: string
          updated_at?: string
        }
        Update: {
          amount?: number
          app_comms?: Json | null
          app_comms_updated_at?: string | null
          audiences?: NonNullable<Json>
          created_at?: string
          created_by?: string | null
          end_date?: string | null
          id?: string
          name?: string
          one_route_per_day?: boolean
          pay_description?: string
          period?: string
          route_cycles?: string[]
          route_types?: string[]
          start_date?: string
          status?: string
          threshold?: number | null
          unit?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "incentives_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      invoices: {
        Row: {
          amount: number | null
          created_at: string | null
          date: string | null
          external_id: string | null
          id: string
          invoice_id: string
          invoice_url: string | null
          people_id: string | null
          period: string | null
          person_id: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          amount?: number | null
          created_at?: string | null
          date?: string | null
          external_id?: string | null
          id?: string
          invoice_id: string
          invoice_url?: string | null
          people_id?: string | null
          period?: string | null
          person_id?: string | null
          updated_at?: string | null
        }
        Update: {
          amount?: number | null
          created_at?: string | null
          date?: string | null
          external_id?: string | null
          id?: string
          invoice_id?: string
          invoice_url?: string | null
          people_id?: string | null
          period?: string | null
          person_id?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "invoices_people_id_fkey"
            columns: ["people_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
        ]
      }
      jobs: {
        Row: {
          active: boolean | null
          contract: string
          created_at: string | null
          data_collection_only: boolean | null
          depot_id: string | null
          description: string | null
          driver_manager_team: string | null
          driver_manager_team_id: string | null
          dsp: string | null
          dsp_contact_emails: string | null
          dsp_id: string | null
          employer: string | null
          hidden: boolean | null
          id: string
          pass_mark_driver_onroad_test: number | null
          pass_mark_np: string | null
          pass_mark_sjt: string | null
          pay_basis: Database["public"]["Enums"]["pay_basis"] | null
          pay_group: Database["public"]["Enums"]["pay_group"] | null
          pay_rate: number | null
          person_type: string | null
          salary: string | null
          sheriff_type: string | null
          shift_areas: string[] | null
          stages: Json[] | null
          title: string | null
          updated_at: string | null
          url: string | null
          vehicle_type: string | null
        }
        ComputedFields: never
        Insert: {
          active?: boolean | null
          contract?: string
          created_at?: string | null
          data_collection_only?: boolean | null
          depot_id?: string | null
          description?: string | null
          driver_manager_team?: string | null
          driver_manager_team_id?: string | null
          dsp?: string | null
          dsp_contact_emails?: string | null
          dsp_id?: string | null
          employer?: string | null
          hidden?: boolean | null
          id?: string
          pass_mark_driver_onroad_test?: number | null
          pass_mark_np?: string | null
          pass_mark_sjt?: string | null
          pay_basis?: Database["public"]["Enums"]["pay_basis"] | null
          pay_group?: Database["public"]["Enums"]["pay_group"] | null
          pay_rate?: number | null
          person_type?: string | null
          salary?: string | null
          sheriff_type?: string | null
          shift_areas?: string[] | null
          stages?: Json[] | null
          title?: string | null
          updated_at?: string | null
          url?: string | null
          vehicle_type?: string | null
        }
        Update: {
          active?: boolean | null
          contract?: string
          created_at?: string | null
          data_collection_only?: boolean | null
          depot_id?: string | null
          description?: string | null
          driver_manager_team?: string | null
          driver_manager_team_id?: string | null
          dsp?: string | null
          dsp_contact_emails?: string | null
          dsp_id?: string | null
          employer?: string | null
          hidden?: boolean | null
          id?: string
          pass_mark_driver_onroad_test?: number | null
          pass_mark_np?: string | null
          pass_mark_sjt?: string | null
          pay_basis?: Database["public"]["Enums"]["pay_basis"] | null
          pay_group?: Database["public"]["Enums"]["pay_group"] | null
          pay_rate?: number | null
          person_type?: string | null
          salary?: string | null
          sheriff_type?: string | null
          shift_areas?: string[] | null
          stages?: Json[] | null
          title?: string | null
          updated_at?: string | null
          url?: string | null
          vehicle_type?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "jobs_depot_id_fkey"
            columns: ["depot_id"]
            isOneToOne: false
            referencedRelation: "depots"
            referencedColumns: ["id"]
          },
        ]
      }
      keyless_pin_attempts: {
        Row: {
          attempted_at: string
          id: string
          outcome: string
        }
        ComputedFields: never
        Insert: {
          attempted_at?: string
          id?: string
          outcome: string
        }
        Update: {
          attempted_at?: string
          id?: string
          outcome?: string
        }
        Relationships: []
      }
      password_reset_requests: {
        Row: {
          email_hash: string
          id: string
          requested_at: string
        }
        ComputedFields: never
        Insert: {
          email_hash: string
          id?: string
          requested_at?: string
        }
        Update: {
          email_hash?: string
          id?: string
          requested_at?: string
        }
        Relationships: []
      }
      payments: {
        Row: {
          amount: number | null
          breakdown: Json | null
          created_at: string | null
          date: string | null
          external_id: string | null
          id: string
          payment_id: string
          payment_status: string | null
          people_id: string | null
          performance_score: string | null
          performance_tier: Json | null
          person_id: string | null
          route: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          amount?: number | null
          breakdown?: Json | null
          created_at?: string | null
          date?: string | null
          external_id?: string | null
          id?: string
          payment_id: string
          payment_status?: string | null
          people_id?: string | null
          performance_score?: string | null
          performance_tier?: Json | null
          person_id?: string | null
          route?: string | null
          updated_at?: string | null
        }
        Update: {
          amount?: number | null
          breakdown?: Json | null
          created_at?: string | null
          date?: string | null
          external_id?: string | null
          id?: string
          payment_id?: string
          payment_status?: string | null
          people_id?: string | null
          performance_score?: string | null
          performance_tier?: Json | null
          person_id?: string | null
          route?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "payments_people_id_fkey"
            columns: ["people_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
        ]
      }
      pcn_details: {
        Row: {
          charge_to_driver: boolean | null
          contravention_code: string | null
          created_at: string | null
          id: string
          infringement_type: string | null
          location_of_contravention: string | null
          passcode: string | null
          pcn_issued_by: string | null
          pcn_number: string | null
          penalty_type: string | null
          ticket_id: string | null
          total_charge_amount: number | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          charge_to_driver?: boolean | null
          contravention_code?: string | null
          created_at?: string | null
          id?: string
          infringement_type?: string | null
          location_of_contravention?: string | null
          passcode?: string | null
          pcn_issued_by?: string | null
          pcn_number?: string | null
          penalty_type?: string | null
          ticket_id?: string | null
          total_charge_amount?: number | null
          updated_at?: string | null
        }
        Update: {
          charge_to_driver?: boolean | null
          contravention_code?: string | null
          created_at?: string | null
          id?: string
          infringement_type?: string | null
          location_of_contravention?: string | null
          passcode?: string | null
          pcn_issued_by?: string | null
          pcn_number?: string | null
          penalty_type?: string | null
          ticket_id?: string | null
          total_charge_amount?: number | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "pcn_details_ticket_id_fkey"
            columns: ["ticket_id"]
            isOneToOne: true
            referencedRelation: "tickets"
            referencedColumns: ["id"]
          },
        ]
      }
      people: {
        Row: {
          address_line_1: string | null
          address_line_2: string | null
          airtable_record_id: string | null
          bank_account_number: string | null
          bank_name: string | null
          bank_proof: string | null
          bank_sort_code: string | null
          city: string | null
          company_name: string | null
          company_number: string | null
          contract: Json | null
          contract_end_date: string | null
          contract_start_date: string | null
          contract_type: string | null
          created_at: string
          date_of_birth: string | null
          driver_manager_team: string | null
          driver_status_internal: string | null
          driver_trainer_responsible: string | null
          dsp_id: string | null
          efficiency_multiplier: number | null
          email: string | null
          employer: string | null
          exported_to_pay_captain: boolean | null
          first_name: string | null
          hpd_pool: string | null
          id: string
          insurance_proof: string | null
          location: string[] | null
          max_duration: number | null
          min_commitment: number | null
          name_on_bank_account: string | null
          national_insurance_number: string | null
          next_of_kin_name: string | null
          next_of_kin_phone: string | null
          next_of_kin_relation: string | null
          offboarding_notes: string | null
          offboarding_reason: string | null
          pay_basis: Database["public"]["Enums"]["pay_basis"] | null
          pay_group: Database["public"]["Enums"]["pay_group"] | null
          pay_rate: number | null
          payment_basis: Database["public"]["Enums"]["payment_basis"] | null
          payment_provider: string | null
          person: string | null
          person_id: string | null
          phone_number: string | null
          postcode: string | null
          primary_person_id: string | null
          right_to_work: string | null
          role: Database["public"]["Enums"]["person_role"] | null
          salaried_hours: number | null
          salary: number | null
          sex: string | null
          sheriff_areas: Database["public"]["Enums"]["person_areas"][] | null
          sheriff_employer: string | null
          sheriff_type: Database["public"]["Enums"]["person_type"] | null
          starter_declaration: string | null
          status: string | null
          sticky_location: string | null
          student_loan_graduate_plan: string | null
          student_loan_plan_1: string | null
          student_loan_plan_2: string | null
          student_loan_plan_4: string | null
          surname: string | null
          track_pod_username: string | null
          unassigned_cost: number | null
          unique_taxpayer_reference: number | null
          updated_at: string
          user_id: string | null
          vat_number: string | null
          vehicle_release_form: string | null
          vehicle_rental_company: string | null
          zerity_id: string | null
          dispatch_person_sync_payload: Json | null
          has_multiple_locations: boolean | null
        }
        ComputedFields: "dispatch_person_sync_payload" | "has_multiple_locations"
        Insert: {
          address_line_1?: string | null
          address_line_2?: string | null
          airtable_record_id?: string | null
          bank_account_number?: string | null
          bank_name?: string | null
          bank_proof?: string | null
          bank_sort_code?: string | null
          city?: string | null
          company_name?: string | null
          company_number?: string | null
          contract?: Json | null
          contract_end_date?: string | null
          contract_start_date?: string | null
          contract_type?: string | null
          created_at?: string
          date_of_birth?: string | null
          driver_manager_team?: string | null
          driver_status_internal?: string | null
          driver_trainer_responsible?: string | null
          dsp_id?: string | null
          efficiency_multiplier?: number | null
          email?: string | null
          employer?: string | null
          exported_to_pay_captain?: boolean | null
          first_name?: string | null
          hpd_pool?: string | null
          id?: string
          insurance_proof?: string | null
          location?: string[] | null
          max_duration?: number | null
          min_commitment?: number | null
          name_on_bank_account?: string | null
          national_insurance_number?: string | null
          next_of_kin_name?: string | null
          next_of_kin_phone?: string | null
          next_of_kin_relation?: string | null
          offboarding_notes?: string | null
          offboarding_reason?: string | null
          pay_basis?: Database["public"]["Enums"]["pay_basis"] | null
          pay_group?: Database["public"]["Enums"]["pay_group"] | null
          pay_rate?: number | null
          payment_basis?: Database["public"]["Enums"]["payment_basis"] | null
          payment_provider?: string | null
          person?: string | null
          person_id?: string | null
          phone_number?: string | null
          postcode?: string | null
          primary_person_id?: string | null
          right_to_work?: string | null
          role?: Database["public"]["Enums"]["person_role"] | null
          salaried_hours?: number | null
          salary?: number | null
          sex?: string | null
          sheriff_areas?: Database["public"]["Enums"]["person_areas"][] | null
          sheriff_employer?: string | null
          sheriff_type?: Database["public"]["Enums"]["person_type"] | null
          starter_declaration?: string | null
          status?: string | null
          sticky_location?: string | null
          student_loan_graduate_plan?: string | null
          student_loan_plan_1?: string | null
          student_loan_plan_2?: string | null
          student_loan_plan_4?: string | null
          surname?: string | null
          track_pod_username?: string | null
          unassigned_cost?: number | null
          unique_taxpayer_reference?: number | null
          updated_at?: string
          user_id?: string | null
          vat_number?: string | null
          vehicle_release_form?: string | null
          vehicle_rental_company?: string | null
          zerity_id?: string | null
        }
        Update: {
          address_line_1?: string | null
          address_line_2?: string | null
          airtable_record_id?: string | null
          bank_account_number?: string | null
          bank_name?: string | null
          bank_proof?: string | null
          bank_sort_code?: string | null
          city?: string | null
          company_name?: string | null
          company_number?: string | null
          contract?: Json | null
          contract_end_date?: string | null
          contract_start_date?: string | null
          contract_type?: string | null
          created_at?: string
          date_of_birth?: string | null
          driver_manager_team?: string | null
          driver_status_internal?: string | null
          driver_trainer_responsible?: string | null
          dsp_id?: string | null
          efficiency_multiplier?: number | null
          email?: string | null
          employer?: string | null
          exported_to_pay_captain?: boolean | null
          first_name?: string | null
          hpd_pool?: string | null
          id?: string
          insurance_proof?: string | null
          location?: string[] | null
          max_duration?: number | null
          min_commitment?: number | null
          name_on_bank_account?: string | null
          national_insurance_number?: string | null
          next_of_kin_name?: string | null
          next_of_kin_phone?: string | null
          next_of_kin_relation?: string | null
          offboarding_notes?: string | null
          offboarding_reason?: string | null
          pay_basis?: Database["public"]["Enums"]["pay_basis"] | null
          pay_group?: Database["public"]["Enums"]["pay_group"] | null
          pay_rate?: number | null
          payment_basis?: Database["public"]["Enums"]["payment_basis"] | null
          payment_provider?: string | null
          person?: string | null
          person_id?: string | null
          phone_number?: string | null
          postcode?: string | null
          primary_person_id?: string | null
          right_to_work?: string | null
          role?: Database["public"]["Enums"]["person_role"] | null
          salaried_hours?: number | null
          salary?: number | null
          sex?: string | null
          sheriff_areas?: Database["public"]["Enums"]["person_areas"][] | null
          sheriff_employer?: string | null
          sheriff_type?: Database["public"]["Enums"]["person_type"] | null
          starter_declaration?: string | null
          status?: string | null
          sticky_location?: string | null
          student_loan_graduate_plan?: string | null
          student_loan_plan_1?: string | null
          student_loan_plan_2?: string | null
          student_loan_plan_4?: string | null
          surname?: string | null
          track_pod_username?: string | null
          unassigned_cost?: number | null
          unique_taxpayer_reference?: number | null
          updated_at?: string
          user_id?: string | null
          vat_number?: string | null
          vehicle_release_form?: string | null
          vehicle_rental_company?: string | null
          zerity_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "people_primary_person_id_fkey"
            columns: ["primary_person_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "people_user_id_fkey"
            columns: ["user_id"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      role_permissions: {
        Row: {
          created_at: string | null
          id: string
          permission: Database["public"]["Enums"]["role_permission"]
          role: Database["public"]["Enums"]["app_role"]
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          created_at?: string | null
          id?: string
          permission: Database["public"]["Enums"]["role_permission"]
          role: Database["public"]["Enums"]["app_role"]
          updated_at?: string | null
        }
        Update: {
          created_at?: string | null
          id?: string
          permission?: Database["public"]["Enums"]["role_permission"]
          role?: Database["public"]["Enums"]["app_role"]
          updated_at?: string | null
        }
        Relationships: []
      }
      session_bookings: {
        Row: {
          application_id: string | null
          attended: boolean | null
          cancellation_reason: string | null
          cancelled_at: string | null
          created_at: string | null
          date: string | null
          id: string
          session_id: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          application_id?: string | null
          attended?: boolean | null
          cancellation_reason?: string | null
          cancelled_at?: string | null
          created_at?: string | null
          date?: string | null
          id?: string
          session_id?: string | null
          updated_at?: string | null
        }
        Update: {
          application_id?: string | null
          attended?: boolean | null
          cancellation_reason?: string | null
          cancelled_at?: string | null
          created_at?: string | null
          date?: string | null
          id?: string
          session_id?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "session_bookings_application_id_fkey"
            columns: ["application_id"]
            isOneToOne: false
            referencedRelation: "applications"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "session_bookings_session_id_fkey"
            columns: ["session_id"]
            isOneToOne: false
            referencedRelation: "sessions"
            referencedColumns: ["id"]
          },
        ]
      }
      session_invalidations: {
        Row: {
          created_at: string
          created_by: string | null
          id: string
          invalidate_at: string
          is_active: boolean
          reason: string | null
          updated_at: string | null
          user_id: string | null
        }
        ComputedFields: never
        Insert: {
          created_at?: string
          created_by?: string | null
          id?: string
          invalidate_at: string
          is_active?: boolean
          reason?: string | null
          updated_at?: string | null
          user_id?: string | null
        }
        Update: {
          created_at?: string
          created_by?: string | null
          id?: string
          invalidate_at?: string
          is_active?: boolean
          reason?: string | null
          updated_at?: string | null
          user_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "session_invalidations_user_id_fkey"
            columns: ["user_id"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      sessions: {
        Row: {
          capacity: number | null
          content_fields: Json | null
          created_at: string | null
          date: string | null
          depot_id: string | null
          end_time: string | null
          id: string
          jobs: string[] | null
          start_time: string | null
          status: string | null
          title: string | null
          type: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          capacity?: number | null
          content_fields?: Json | null
          created_at?: string | null
          date?: string | null
          depot_id?: string | null
          end_time?: string | null
          id?: string
          jobs?: string[] | null
          start_time?: string | null
          status?: string | null
          title?: string | null
          type?: string | null
          updated_at?: string | null
        }
        Update: {
          capacity?: number | null
          content_fields?: Json | null
          created_at?: string | null
          date?: string | null
          depot_id?: string | null
          end_time?: string | null
          id?: string
          jobs?: string[] | null
          start_time?: string | null
          status?: string | null
          title?: string | null
          type?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "sessions_depot_id_fkey"
            columns: ["depot_id"]
            isOneToOne: false
            referencedRelation: "depots"
            referencedColumns: ["id"]
          },
        ]
      }
      shift_waves: {
        Row: {
          created_at: string
          created_by: string | null
          depot_id: string
          id: string
          interval_mins: number
          priority_order: string[]
          rewave_date: string
          start_time: string
          waves: NonNullable<Json>
        }
        ComputedFields: never
        Insert: {
          created_at?: string
          created_by?: string | null
          depot_id: string
          id?: string
          interval_mins: number
          priority_order?: string[]
          rewave_date: string
          start_time: string
          waves: NonNullable<Json>
        }
        Update: {
          created_at?: string
          created_by?: string | null
          depot_id?: string
          id?: string
          interval_mins?: number
          priority_order?: string[]
          rewave_date?: string
          start_time?: string
          waves?: NonNullable<Json>
        }
        Relationships: [
          {
            foreignKeyName: "shift_waves_depot_id_fkey"
            columns: ["depot_id"]
            isOneToOne: false
            referencedRelation: "depots"
            referencedColumns: ["id"]
          },
        ]
      }
      shifts: {
        Row: {
          area: Database["public"]["Enums"]["person_areas"]
          awol: boolean | null
          cancelled_reason: Database["public"]["Enums"]["cancelled_reason"] | null
          cancelled_time: string | null
          created_at: string
          depot_id: string | null
          employer: string
          end_time: string
          id: string
          last_edited_by: string | null
          location: string
          minutes_late: number | null
          notes: string | null
          notifications: boolean
          person_id: string | null
          preassigned_route: string | null
          start_time: string
          status: Database["public"]["Enums"]["shift_status"]
          timesheets_id: string | null
          type: Database["public"]["Enums"]["person_type"]
          updated_at: string
          vehicle_id: string | null
          vehicle_reg: string | null
        }
        ComputedFields: never
        Insert: {
          area: Database["public"]["Enums"]["person_areas"]
          awol?: boolean | null
          cancelled_reason?: Database["public"]["Enums"]["cancelled_reason"] | null
          cancelled_time?: string | null
          created_at?: string
          depot_id?: string | null
          employer: string
          end_time: string
          id?: string
          last_edited_by?: string | null
          location: string
          minutes_late?: number | null
          notes?: string | null
          notifications?: boolean
          person_id?: string | null
          preassigned_route?: string | null
          start_time: string
          status?: Database["public"]["Enums"]["shift_status"]
          timesheets_id?: string | null
          type: Database["public"]["Enums"]["person_type"]
          updated_at?: string
          vehicle_id?: string | null
          vehicle_reg?: string | null
        }
        Update: {
          area?: Database["public"]["Enums"]["person_areas"]
          awol?: boolean | null
          cancelled_reason?: Database["public"]["Enums"]["cancelled_reason"] | null
          cancelled_time?: string | null
          created_at?: string
          depot_id?: string | null
          employer?: string
          end_time?: string
          id?: string
          last_edited_by?: string | null
          location?: string
          minutes_late?: number | null
          notes?: string | null
          notifications?: boolean
          person_id?: string | null
          preassigned_route?: string | null
          start_time?: string
          status?: Database["public"]["Enums"]["shift_status"]
          timesheets_id?: string | null
          type?: Database["public"]["Enums"]["person_type"]
          updated_at?: string
          vehicle_id?: string | null
          vehicle_reg?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "shifts_depot_id_fkey"
            columns: ["depot_id"]
            isOneToOne: false
            referencedRelation: "depots"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "shifts_person_id_fkey"
            columns: ["person_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "shifts_timesheets_id_fkey"
            columns: ["timesheets_id"]
            isOneToOne: false
            referencedRelation: "timesheets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "shifts_vehicle_id_fkey"
            columns: ["vehicle_id"]
            isOneToOne: false
            referencedRelation: "vehicles"
            referencedColumns: ["id"]
          },
        ]
      }
      sticky_locations: {
        Row: {
          active: boolean
          airtable_record_id: string | null
          availability: string | null
          code: string | null
          created_at: string
          id: string
          latitude: string | null
          longitude: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          active?: boolean
          airtable_record_id?: string | null
          availability?: string | null
          code?: string | null
          created_at?: string
          id?: string
          latitude?: string | null
          longitude?: string | null
          updated_at?: string | null
        }
        Update: {
          active?: boolean
          airtable_record_id?: string | null
          availability?: string | null
          code?: string | null
          created_at?: string
          id?: string
          latitude?: string | null
          longitude?: string | null
          updated_at?: string | null
        }
        Relationships: []
      }
      team_permissions: {
        Row: {
          created_at: string | null
          id: string
          permission: Database["public"]["Enums"]["team_permission"]
          team: Database["public"]["Enums"]["app_team"]
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          created_at?: string | null
          id?: string
          permission: Database["public"]["Enums"]["team_permission"]
          team: Database["public"]["Enums"]["app_team"]
          updated_at?: string | null
        }
        Update: {
          created_at?: string | null
          id?: string
          permission?: Database["public"]["Enums"]["team_permission"]
          team?: Database["public"]["Enums"]["app_team"]
          updated_at?: string | null
        }
        Relationships: []
      }
      ticket_amount_rules: {
        Row: {
          amount: number | null
          created_at: string
          driver_type: string
          id: string
          route_cycle: string | null
          ticket_type_id: number
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          amount?: number | null
          created_at?: string
          driver_type: string
          id?: string
          route_cycle?: string | null
          ticket_type_id: number
          updated_at?: string | null
        }
        Update: {
          amount?: number | null
          created_at?: string
          driver_type?: string
          id?: string
          route_cycle?: string | null
          ticket_type_id?: number
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "ticket_amount_rules_ticket_type_id_fkey"
            columns: ["ticket_type_id"]
            isOneToOne: false
            referencedRelation: "ticket_types"
            referencedColumns: ["id"]
          },
        ]
      }
      ticket_types: {
        Row: {
          agency_sortation_amount: number | null
          auto_approve: boolean | null
          category: string | null
          central_operations: boolean | null
          collection_driver_amount: number | null
          created_at: string | null
          customer_service: boolean | null
          depot: boolean | null
          driver_operations: boolean | null
          driver_type: string | null
          driver_visible: boolean | null
          finance: boolean | null
          fleet: boolean | null
          hq_amount: number | null
          id: number
          import_source: string | null
          rc1_agency_driver_amount: number | null
          rc1_dsp_amount: number | null
          rc1_hived_partner_driver_amount: number | null
          rc2_agency_driver_amount: number | null
          rc2_dsp_amount: number | null
          rc2_hived_partner_driver_amount: number | null
          revenue_protection: boolean | null
          severity_level: number | null
          sortation_amount: number | null
          sub_category: string | null
          ticket_name: string
          ticket_name_airtable: string | null
          ticket_name_old: string | null
          ticket_name_value: string | null
          ticket_number: string | null
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          agency_sortation_amount?: number | null
          auto_approve?: boolean | null
          category?: string | null
          central_operations?: boolean | null
          collection_driver_amount?: number | null
          created_at?: string | null
          customer_service?: boolean | null
          depot?: boolean | null
          driver_operations?: boolean | null
          driver_type?: string | null
          driver_visible?: boolean | null
          finance?: boolean | null
          fleet?: boolean | null
          hq_amount?: number | null
          id?: number
          import_source?: string | null
          rc1_agency_driver_amount?: number | null
          rc1_dsp_amount?: number | null
          rc1_hived_partner_driver_amount?: number | null
          rc2_agency_driver_amount?: number | null
          rc2_dsp_amount?: number | null
          rc2_hived_partner_driver_amount?: number | null
          revenue_protection?: boolean | null
          severity_level?: number | null
          sortation_amount?: number | null
          sub_category?: string | null
          ticket_name: string
          ticket_name_airtable?: string | null
          ticket_name_old?: string | null
          ticket_name_value?: string | null
          ticket_number?: string | null
          updated_at?: string | null
        }
        Update: {
          agency_sortation_amount?: number | null
          auto_approve?: boolean | null
          category?: string | null
          central_operations?: boolean | null
          collection_driver_amount?: number | null
          created_at?: string | null
          customer_service?: boolean | null
          depot?: boolean | null
          driver_operations?: boolean | null
          driver_type?: string | null
          driver_visible?: boolean | null
          finance?: boolean | null
          fleet?: boolean | null
          hq_amount?: number | null
          id?: number
          import_source?: string | null
          rc1_agency_driver_amount?: number | null
          rc1_dsp_amount?: number | null
          rc1_hived_partner_driver_amount?: number | null
          rc2_agency_driver_amount?: number | null
          rc2_dsp_amount?: number | null
          rc2_hived_partner_driver_amount?: number | null
          revenue_protection?: boolean | null
          severity_level?: number | null
          sortation_amount?: number | null
          sub_category?: string | null
          ticket_name?: string
          ticket_name_airtable?: string | null
          ticket_name_old?: string | null
          ticket_name_value?: string | null
          ticket_number?: string | null
          updated_at?: string | null
        }
        Relationships: []
      }
      tickets: {
        Row: {
          amount: number | null
          created_at: string
          created_by: string | null
          depot: string | null
          details: string | null
          dsp: string | null
          duration: number | null
          file_path: string | null
          id: string
          people_id: string | null
          person: string | null
          route_code: string | null
          route_cycle: string | null
          status: string | null
          ticket_date_time: string | null
          ticket_type_id: number | null
          tracking_id: string | null
          updated_at: string
          updated_by: string | null
          vehicle: string | null
          webhook_status: Database["public"]["Enums"]["ticket_webhook_status"]
        }
        ComputedFields: never
        Insert: {
          amount?: number | null
          created_at?: string
          created_by?: string | null
          depot?: string | null
          details?: string | null
          dsp?: string | null
          duration?: number | null
          file_path?: string | null
          id?: string
          people_id?: string | null
          person?: string | null
          route_code?: string | null
          route_cycle?: string | null
          status?: string | null
          ticket_date_time?: string | null
          ticket_type_id?: number | null
          tracking_id?: string | null
          updated_at?: string
          updated_by?: string | null
          vehicle?: string | null
          webhook_status?: Database["public"]["Enums"]["ticket_webhook_status"]
        }
        Update: {
          amount?: number | null
          created_at?: string
          created_by?: string | null
          depot?: string | null
          details?: string | null
          dsp?: string | null
          duration?: number | null
          file_path?: string | null
          id?: string
          people_id?: string | null
          person?: string | null
          route_code?: string | null
          route_cycle?: string | null
          status?: string | null
          ticket_date_time?: string | null
          ticket_type_id?: number | null
          tracking_id?: string | null
          updated_at?: string
          updated_by?: string | null
          vehicle?: string | null
          webhook_status?: Database["public"]["Enums"]["ticket_webhook_status"]
        }
        Relationships: [
          {
            foreignKeyName: "tickets_people_id_fkey"
            columns: ["people_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "tickets_ticket_type_id_fkey"
            columns: ["ticket_type_id"]
            isOneToOne: false
            referencedRelation: "ticket_types"
            referencedColumns: ["id"]
          },
        ]
      }
      timesheets: {
        Row: {
          auto_clock_out: boolean
          break: number | null
          clocked_in_time: string
          clocked_out_time: string | null
          clockin_car_park_id: string | null
          clockin_depot_id: string | null
          clockout_depot_id: string | null
          created_at: string
          employer: string | null
          end_latitude: number | null
          end_longitude: number | null
          id: string
          last_edited_by: string | null
          latitude: number
          longitude: number
          person_id: string | null
          shift_id: string | null
          status: Database["public"]["Enums"]["timesheet_status"]
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          auto_clock_out?: boolean
          break?: number | null
          clocked_in_time: string
          clocked_out_time?: string | null
          clockin_car_park_id?: string | null
          clockin_depot_id?: string | null
          clockout_depot_id?: string | null
          created_at?: string
          employer?: string | null
          end_latitude?: number | null
          end_longitude?: number | null
          id?: string
          last_edited_by?: string | null
          latitude: number
          longitude: number
          person_id?: string | null
          shift_id?: string | null
          status?: Database["public"]["Enums"]["timesheet_status"]
          updated_at?: string | null
        }
        Update: {
          auto_clock_out?: boolean
          break?: number | null
          clocked_in_time?: string
          clocked_out_time?: string | null
          clockin_car_park_id?: string | null
          clockin_depot_id?: string | null
          clockout_depot_id?: string | null
          created_at?: string
          employer?: string | null
          end_latitude?: number | null
          end_longitude?: number | null
          id?: string
          last_edited_by?: string | null
          latitude?: number
          longitude?: number
          person_id?: string | null
          shift_id?: string | null
          status?: Database["public"]["Enums"]["timesheet_status"]
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "timesheets_clockin_car_park_id_fkey"
            columns: ["clockin_car_park_id"]
            isOneToOne: false
            referencedRelation: "car_parks"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "timesheets_clockin_depot_id_fkey"
            columns: ["clockin_depot_id"]
            isOneToOne: false
            referencedRelation: "depots"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "timesheets_clockout_depot_id_fkey"
            columns: ["clockout_depot_id"]
            isOneToOne: false
            referencedRelation: "depots"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "timesheets_person_id_fkey"
            columns: ["person_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "timesheets_shift_id_fkey"
            columns: ["shift_id"]
            isOneToOne: false
            referencedRelation: "shifts"
            referencedColumns: ["id"]
          },
        ]
      }
      trial_blocks: {
        Row: {
          additional_trial: boolean | null
          application_id: string | null
          attended: boolean
          comments: string | null
          created_at: string | null
          customer_feedback: string | null
          date: string | null
          delivery_notes: string | null
          delivery_pictures: string | null
          delivery_success_score: string | null
          driving_behaviour: string | null
          id: string
          instruction_compliance: string | null
          issue_resolution: string | null
          load_check: string | null
          location: string | null
          result: string | null
          review_status: string | null
          reviewed_at: string | null
          route_code: string | null
          route_cycle: string | null
          safety_score: number | null
          time_management: string | null
          trial_id: string | null
          updated_at: string | null
          vehicle_handling: string | null
          vehicle_name: string | null
        }
        ComputedFields: never
        Insert: {
          additional_trial?: boolean | null
          application_id?: string | null
          attended?: boolean
          comments?: string | null
          created_at?: string | null
          customer_feedback?: string | null
          date?: string | null
          delivery_notes?: string | null
          delivery_pictures?: string | null
          delivery_success_score?: string | null
          driving_behaviour?: string | null
          id?: string
          instruction_compliance?: string | null
          issue_resolution?: string | null
          load_check?: string | null
          location?: string | null
          result?: string | null
          review_status?: string | null
          reviewed_at?: string | null
          route_code?: string | null
          route_cycle?: string | null
          safety_score?: number | null
          time_management?: string | null
          trial_id?: string | null
          updated_at?: string | null
          vehicle_handling?: string | null
          vehicle_name?: string | null
        }
        Update: {
          additional_trial?: boolean | null
          application_id?: string | null
          attended?: boolean
          comments?: string | null
          created_at?: string | null
          customer_feedback?: string | null
          date?: string | null
          delivery_notes?: string | null
          delivery_pictures?: string | null
          delivery_success_score?: string | null
          driving_behaviour?: string | null
          id?: string
          instruction_compliance?: string | null
          issue_resolution?: string | null
          load_check?: string | null
          location?: string | null
          result?: string | null
          review_status?: string | null
          reviewed_at?: string | null
          route_code?: string | null
          route_cycle?: string | null
          safety_score?: number | null
          time_management?: string | null
          trial_id?: string | null
          updated_at?: string | null
          vehicle_handling?: string | null
          vehicle_name?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "trial_blocks_application_id_fkey"
            columns: ["application_id"]
            isOneToOne: false
            referencedRelation: "applications"
            referencedColumns: ["id"]
          },
        ]
      }
      unavailability: {
        Row: {
          created_at: string | null
          end_time: string
          id: string
          notes: string | null
          person_id: string | null
          start_time: string
          status: Database["public"]["Enums"]["unavailability_status"]
          type: Database["public"]["Enums"]["unavailability_type"]
          updated_at: string | null
        }
        ComputedFields: never
        Insert: {
          created_at?: string | null
          end_time: string
          id?: string
          notes?: string | null
          person_id?: string | null
          start_time: string
          status?: Database["public"]["Enums"]["unavailability_status"]
          type: Database["public"]["Enums"]["unavailability_type"]
          updated_at?: string | null
        }
        Update: {
          created_at?: string | null
          end_time?: string
          id?: string
          notes?: string | null
          person_id?: string | null
          start_time?: string
          status?: Database["public"]["Enums"]["unavailability_status"]
          type?: Database["public"]["Enums"]["unavailability_type"]
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "unavailability_person_id_fkey"
            columns: ["person_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
        ]
      }
      users: {
        Row: {
          areas: Database["public"]["Enums"]["person_areas"][] | null
          created_at: string
          deleted_at: string | null
          driver_manager_team_id: string | null
          dsp_id: string | null
          email: string | null
          employer: string | null
          first_name: string | null
          full_name: string | null
          id: string
          is_active: boolean
          last_name: string | null
          location: string[] | null
          marked_for_deletion: boolean
          max_duration: number | null
          min_commitment: number | null
          payment_added_at: string | null
          person: string | null
          person_id: string | null
          phone_number: string | null
          primary_person_id: string | null
          rc_1_outcode: string | null
          role: Database["public"]["Enums"]["app_role"] | null
          status: Database["public"]["Enums"]["person_status"] | null
          stripe_customer_id: string | null
          stripe_payment_method_id: string | null
          sub_teams: string[] | null
          team: Database["public"]["Enums"]["app_team"] | null
          type: Database["public"]["Enums"]["person_type"] | null
          unassigned_cost: number | null
          updated_at: string
        }
        ComputedFields: never
        Insert: {
          areas?: Database["public"]["Enums"]["person_areas"][] | null
          created_at?: string
          deleted_at?: string | null
          driver_manager_team_id?: string | null
          dsp_id?: string | null
          email?: string | null
          employer?: string | null
          first_name?: string | null
          full_name?: string | null
          id: string
          is_active?: boolean
          last_name?: string | null
          location?: string[] | null
          marked_for_deletion?: boolean
          max_duration?: number | null
          min_commitment?: number | null
          payment_added_at?: string | null
          person?: string | null
          person_id?: string | null
          phone_number?: string | null
          primary_person_id?: string | null
          rc_1_outcode?: string | null
          role?: Database["public"]["Enums"]["app_role"] | null
          status?: Database["public"]["Enums"]["person_status"] | null
          stripe_customer_id?: string | null
          stripe_payment_method_id?: string | null
          sub_teams?: string[] | null
          team?: Database["public"]["Enums"]["app_team"] | null
          type?: Database["public"]["Enums"]["person_type"] | null
          unassigned_cost?: number | null
          updated_at?: string
        }
        Update: {
          areas?: Database["public"]["Enums"]["person_areas"][] | null
          created_at?: string
          deleted_at?: string | null
          driver_manager_team_id?: string | null
          dsp_id?: string | null
          email?: string | null
          employer?: string | null
          first_name?: string | null
          full_name?: string | null
          id?: string
          is_active?: boolean
          last_name?: string | null
          location?: string[] | null
          marked_for_deletion?: boolean
          max_duration?: number | null
          min_commitment?: number | null
          payment_added_at?: string | null
          person?: string | null
          person_id?: string | null
          phone_number?: string | null
          primary_person_id?: string | null
          rc_1_outcode?: string | null
          role?: Database["public"]["Enums"]["app_role"] | null
          status?: Database["public"]["Enums"]["person_status"] | null
          stripe_customer_id?: string | null
          stripe_payment_method_id?: string | null
          sub_teams?: string[] | null
          team?: Database["public"]["Enums"]["app_team"] | null
          type?: Database["public"]["Enums"]["person_type"] | null
          unassigned_cost?: number | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "users_primary_person_id_fkey"
            columns: ["primary_person_id"]
            isOneToOne: false
            referencedRelation: "users"
            referencedColumns: ["id"]
          },
        ]
      }
      vehicle_keyless_audit_log: {
        Row: {
          actor_latitude: number | null
          actor_longitude: number | null
          actor_people_id: string | null
          created_at: string
          event_type: string
          failure_detail: Json | null
          failure_reason: string | null
          id: string
          observed_at: string | null
          observed_driving_enabled: boolean | null
          observed_latitude: number | null
          observed_lock_state: string | null
          observed_longitude: number | null
          provider_reference: string | null
          result: string | null
          source: string
          vehicle_id: string
        }
        ComputedFields: never
        Insert: {
          actor_latitude?: number | null
          actor_longitude?: number | null
          actor_people_id?: string | null
          created_at?: string
          event_type: string
          failure_detail?: Json | null
          failure_reason?: string | null
          id?: string
          observed_at?: string | null
          observed_driving_enabled?: boolean | null
          observed_latitude?: number | null
          observed_lock_state?: string | null
          observed_longitude?: number | null
          provider_reference?: string | null
          result?: string | null
          source: string
          vehicle_id: string
        }
        Update: {
          actor_latitude?: number | null
          actor_longitude?: number | null
          actor_people_id?: string | null
          created_at?: string
          event_type?: string
          failure_detail?: Json | null
          failure_reason?: string | null
          id?: string
          observed_at?: string | null
          observed_driving_enabled?: boolean | null
          observed_latitude?: number | null
          observed_lock_state?: string | null
          observed_longitude?: number | null
          provider_reference?: string | null
          result?: string | null
          source?: string
          vehicle_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "vehicle_keyless_audit_log_actor_people_id_fkey"
            columns: ["actor_people_id"]
            isOneToOne: false
            referencedRelation: "people"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicle_keyless_audit_log_vehicle_id_fkey"
            columns: ["vehicle_id"]
            isOneToOne: false
            referencedRelation: "vehicles"
            referencedColumns: ["id"]
          },
        ]
      }
      vehicle_providers: {
        Row: {
          created_at: string
          deactivated_at: string | null
          id: string
          last_synced_at: string | null
          provider: string
          provider_metadata: Json | null
          provider_reference: string
          provider_updated_at: string | null
          updated_at: string
          vehicle_id: string
        }
        ComputedFields: never
        Insert: {
          created_at?: string
          deactivated_at?: string | null
          id?: string
          last_synced_at?: string | null
          provider: string
          provider_metadata?: Json | null
          provider_reference: string
          provider_updated_at?: string | null
          updated_at?: string
          vehicle_id: string
        }
        Update: {
          created_at?: string
          deactivated_at?: string | null
          id?: string
          last_synced_at?: string | null
          provider?: string
          provider_metadata?: Json | null
          provider_reference?: string
          provider_updated_at?: string | null
          updated_at?: string
          vehicle_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "vehicle_providers_vehicle_id_fkey"
            columns: ["vehicle_id"]
            isOneToOne: false
            referencedRelation: "vehicles"
            referencedColumns: ["id"]
          },
        ]
      }
      vehicles: {
        Row: {
          battery_percent: number | null
          car_park_id: string | null
          charging_status: string | null
          created_at: string
          depot_id: string | null
          driving_enabled: boolean | null
          id: string
          latitude: number | null
          lock_state: string | null
          lock_state_observed_at: string | null
          longitude: number | null
          operational_status: string | null
          registration: string
          registration_display: string
          updated_at: string
          vehicle_group: string | null
        }
        ComputedFields: never
        Insert: {
          battery_percent?: number | null
          car_park_id?: string | null
          charging_status?: string | null
          created_at?: string
          depot_id?: string | null
          driving_enabled?: boolean | null
          id?: string
          latitude?: number | null
          lock_state?: string | null
          lock_state_observed_at?: string | null
          longitude?: number | null
          operational_status?: string | null
          registration: string
          registration_display: string
          updated_at?: string
          vehicle_group?: string | null
        }
        Update: {
          battery_percent?: number | null
          car_park_id?: string | null
          charging_status?: string | null
          created_at?: string
          depot_id?: string | null
          driving_enabled?: boolean | null
          id?: string
          latitude?: number | null
          lock_state?: string | null
          lock_state_observed_at?: string | null
          longitude?: number | null
          operational_status?: string | null
          registration?: string
          registration_display?: string
          updated_at?: string
          vehicle_group?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "vehicles_car_park_id_fkey"
            columns: ["car_park_id"]
            isOneToOne: false
            referencedRelation: "car_parks"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vehicles_depot_id_fkey"
            columns: ["depot_id"]
            isOneToOne: false
            referencedRelation: "depots"
            referencedColumns: ["id"]
          },
        ]
      }
    }
    Views: {
      [_ in never]: never
    }
    Functions: {
      audit_log_diff: { Args: { new_row: Json; old_row: Json }; Returns: Json }
      auth_person_id: { Args: Record<PropertyKey, never>; Returns: string }
      can_access_amendment_action: {
        Args: { action: string; amendment_uuid: string; table_name: string }
        Returns: boolean
      }
      can_access_application_action: {
        Args: { action: string; app_id: string; table_name: string }
        Returns: boolean
      }
      can_access_conduct_action: {
        Args: { action: string; conduct_uuid: string; table_name: string }
        Returns: boolean
      }
      can_access_invoice_action: {
        Args: { action: string; invoice_uuid: string; table_name: string }
        Returns: boolean
      }
      can_access_person_record: {
        Args: { action: string; record_person_id: string; table_name: string }
        Returns: boolean
      }
      can_manage_person: { Args: { target_person_id: string }; Returns: boolean }
      can_person_access_action: {
        Args: { action: string; payment_uuid: string; table_name: string }
        Returns: boolean
      }
      can_reactivate_person: { Args: { p_person_id: string }; Returns: boolean }
      can_read_audit_log: {
        Args: {
          target_action?: string
          target_change_set?: Json
          target_record_id: string
          target_table_name: string
        }
        Returns: boolean
      }
      consume_password_reset_request: {
        Args: {
          p_email_hash: string
          p_max_global: number
          p_max_per_email: number
          p_window_seconds: number
        }
        Returns: string
      }
      create_partition: {
        Args: { parent_table: string; partition_interval: string; target_date: string }
        Returns: string
      }
      current_subteams: { Args: Record<PropertyKey, never>; Returns: string[] }
      custom_access_token_hook: { Args: { event: Json }; Returns: Json }
      dispatch_person_sync_payload: {
        Args: {
          person_row: Omit<
            Database["public"]["Tables"]["people"]["Row"],
            Database["public"]["Tables"]["people"]["ComputedFields"]
          >
        }
        Returns: Json
      }
      drop_expired_partitions: {
        Args: { parent_table: string; partition_interval: string; retention_intervals: number }
        Returns: string[]
      }
      get_shift_audit_logs: {
        Args: { result_limit?: number; target_shift_id: string; target_timesheet_id?: string }
        Returns: {
          action: string
          actor: string
          changes: Json
          comment: string
          created_at: string
          id: string
          record_id: string
          table_name: string
        }[]
      }
      has_multiple_locations: {
        Args: { "": Database["public"]["Tables"]["people"]["Row"] }
        Returns: {
          error: true
        } & "the function public.has_multiple_locations with parameter or with a single unnamed json/jsonb parameter, but no matches were found in the schema cache"
      }
      has_permission: { Args: { permission: string }; Returns: boolean }
      has_team_permission: { Args: { permission: string }; Returns: boolean }
      http_request: {
        Args: {
          body?: Json
          caller: string
          headers?: Json
          log_context?: Json
          method: string
          params?: Json
          timeout_milliseconds?: number
          url: string
        }
        Returns: number
      }
      is_admin: { Args: Record<PropertyKey, never>; Returns: boolean }
      is_driver: { Args: Record<PropertyKey, never>; Returns: boolean }
      is_dsp: { Args: Record<PropertyKey, never>; Returns: boolean }
      is_manager: { Args: Record<PropertyKey, never>; Returns: boolean }
      is_vehicle_assigned_to_auth_person: { Args: { target_vehicle_id: string }; Returns: boolean }
      maintain_partitions: {
        Args: {
          intervals_ahead?: number
          parent_table: string
          partition_interval?: string
          retention_intervals?: number
        }
        Returns: Json
      }
      next_person_id: { Args: Record<PropertyKey, never>; Returns: string }
      normalise_registration: { Args: { registration: string }; Returns: string }
      normalize_audit_log_change_set: { Args: { change_set: Json }; Returns: Json }
      partition_interval_length: {
        Args: { interval_count: number; partition_interval: string }
        Returns: string
      }
      partition_name_format: { Args: { partition_interval: string }; Returns: string }
      partition_name_pattern: { Args: { partition_interval: string }; Returns: string }
      partition_range_start: {
        Args: { partition_interval: string; target_date: string }
        Returns: string
      }
      publish_rewave: {
        Args: {
          p_depot_id: string
          p_interval_mins: number
          p_priority_order: string[]
          p_rewave_date: string
          p_shift_updates?: Json
          p_start_time: string
          p_waves: Json
        }
        Returns: string
      }
      reactivate_auth_user: { Args: { target_user_id: string }; Returns: undefined }
      resolve_audit_actor: { Args: Record<PropertyKey, never>; Returns: Record<string, unknown> }
      resolve_audit_actor_user_id: { Args: { candidate: string }; Returns: string }
      resolve_audit_person_label: { Args: { target_person_id: string }; Returns: string }
      resolve_request_last_edited_by: { Args: Record<PropertyKey, never>; Returns: string }
      resolve_shift_audit_comment: { Args: Record<PropertyKey, never>; Returns: string }
      select_due_dvla_drivers: {
        Args: { p_cutoff: string; p_driving_areas: string[]; p_max_checks: number }
        Returns: {
          drivingLicenceNumber: string
          personId: string
        }[]
      }
      shift_audience_options: { Args: Record<PropertyKey, never>; Returns: Json }
      upsert_vehicle_providers: {
        Args: { p_rows: Database["public"]["CompositeTypes"]["vehicle_provider_upsert_row"][] }
        Returns: undefined
      }
    }
    Enums: {
      app_role: "Admin" | "Manager" | "Driver" | "DSP"
      app_team:
        | "Central Operations"
        | "Driver Operations"
        | "Customer Service"
        | "Fleet"
        | "Depot"
        | "Revenue Protection"
        | "Finance"
        | "Admin"
        | "DSP Manager"
      cancelled_reason:
        | "Sickness"
        | "FamilyEmergency"
        | "OtherWorkCommitments"
        | "HivedCapacity"
        | "RetailerRequest"
        | "Offboarded"
        | "RequestedByDriver"
        | "RequestedByDsp"
        | "UnavailabilityRequest"
        | "MovedPosition"
        | "Onboarded"
        | "SheriffTypeChanged"
      pay_basis: "Hourly" | "Daily" | "Monthly"
      pay_group: "Fortnightly" | "Monthly"
      payment_basis: "Route-based" | "Hourly-based" | "Salary"
      person_areas:
        | "Rc1 Deliveries"
        | "Rc2 Deliveries"
        | "Collections"
        | "Fleet Team"
        | "Sortation"
        | "Depot"
        | "Network"
        | "Live Ops"
        | "Customer Service"
        | "Driver Ops"
        | "Driver Partnerships"
        | "Driver Resourcing"
        | "Dsp Managers"
        | "Cx"
        | "Des"
        | "Hq"
      person_employer: "HIVED" | "Self Employed" | "DSP" | "Agency" | "Not Employed"
      person_role:
        | "HIVED Partner Driver"
        | "HIVED Partner Driver (PM)"
        | "DSP"
        | "Agency Driver"
        | "Collection Driver"
        | "Sortation"
        | "Agency Sortation"
        | "HQ"
      person_status: "Applicant" | "Trial" | "Active" | "Inactive"
      person_type:
        | "HivedVan"
        | "HivedHgv"
        | "HivedFlex"
        | "TakeHomeVan"
        | "Dsp"
        | "Trial"
        | "Internal"
        | "Flex"
        | "AssociateDriver"
      role_permission:
        | "create.own.applications"
        | "create.any.applications"
        | "update.own.applications"
        | "update.any.applications"
        | "read.own.applications"
        | "read.any.applications"
        | "delete.any.applications"
        | "delete.own.applications"
        | "read.any.anonymous_visitors"
        | "read.own.anonymous_visitors"
        | "create.any.anonymous_visitors"
        | "create.own.anonymous_visitors"
        | "update.any.anonymous_visitors"
        | "update.own.anonymous_visitors"
        | "delete.any.anonymous_visitors"
        | "delete.own.anonymous_visitors"
        | "read.any.depots"
        | "read.own.depots"
        | "create.any.depots"
        | "create.own.depots"
        | "update.any.depots"
        | "update.own.depots"
        | "delete.any.depots"
        | "delete.own.depots"
        | "read.any.action_costs"
        | "read.own.action_costs"
        | "create.any.action_costs"
        | "create.own.action_costs"
        | "update.any.action_costs"
        | "update.own.action_costs"
        | "delete.any.action_costs"
        | "delete.own.action_costs"
        | "read.any.jobs"
        | "read.own.jobs"
        | "create.any.jobs"
        | "create.own.jobs"
        | "update.any.jobs"
        | "update.own.jobs"
        | "delete.any.jobs"
        | "delete.own.jobs"
        | "read.any.team_permissions"
        | "read.own.team_permissions"
        | "create.any.team_permissions"
        | "create.own.team_permissions"
        | "update.any.team_permissions"
        | "update.own.team_permissions"
        | "delete.any.team_permissions"
        | "delete.own.team_permissions"
        | "read.any.role_permissions"
        | "read.own.role_permissions"
        | "create.any.role_permissions"
        | "create.own.role_permissions"
        | "update.any.role_permissions"
        | "update.own.role_permissions"
        | "delete.any.role_permissions"
        | "delete.own.role_permissions"
        | "read.any.application_stage_history"
        | "read.own.application_stage_history"
        | "create.any.application_stage_history"
        | "create.own.application_stage_history"
        | "update.any.application_stage_history"
        | "update.own.application_stage_history"
        | "delete.any.application_stage_history"
        | "delete.own.application_stage_history"
        | "read.any.driver_dvla_checks"
        | "read.own.driver_dvla_checks"
        | "create.any.driver_dvla_checks"
        | "create.own.driver_dvla_checks"
        | "update.any.driver_dvla_checks"
        | "update.own.driver_dvla_checks"
        | "delete.any.driver_dvla_checks"
        | "delete.own.driver_dvla_checks"
        | "read.any.shifts"
        | "read.own.shifts"
        | "create.any.shifts"
        | "create.own.shifts"
        | "update.any.shifts"
        | "update.own.shifts"
        | "delete.any.shifts"
        | "delete.own.shifts"
        | "read.any.timesheets"
        | "read.own.timesheets"
        | "create.any.timesheets"
        | "create.own.timesheets"
        | "update.any.timesheets"
        | "update.own.timesheets"
        | "delete.any.timesheets"
        | "delete.own.timesheets"
        | "read.any.assessments"
        | "read.own.assessments"
        | "create.any.assessments"
        | "create.own.assessments"
        | "update.any.assessments"
        | "update.own.assessments"
        | "delete.any.assessments"
        | "delete.own.assessments"
        | "read.any.comments"
        | "read.own.comments"
        | "create.any.comments"
        | "create.own.comments"
        | "update.any.comments"
        | "update.own.comments"
        | "delete.any.comments"
        | "delete.own.comments"
        | "read.any.unavailability"
        | "read.own.unavailability"
        | "create.any.unavailability"
        | "create.own.unavailability"
        | "update.any.unavailability"
        | "update.own.unavailability"
        | "delete.any.unavailability"
        | "delete.own.unavailability"
        | "read.any.auth_session_cache"
        | "read.own.auth_session_cache"
        | "create.any.auth_session_cache"
        | "create.own.auth_session_cache"
        | "update.any.auth_session_cache"
        | "update.own.auth_session_cache"
        | "delete.any.auth_session_cache"
        | "delete.own.auth_session_cache"
        | "read.any.applicants"
        | "read.own.applicants"
        | "create.any.applicants"
        | "create.own.applicants"
        | "update.any.applicants"
        | "update.own.applicants"
        | "delete.any.applicants"
        | "delete.own.applicants"
        | "read.any.documents"
        | "read.own.documents"
        | "create.any.documents"
        | "create.own.documents"
        | "update.any.documents"
        | "update.own.documents"
        | "delete.any.documents"
        | "delete.own.documents"
        | "read.any.session_bookings"
        | "read.own.session_bookings"
        | "create.any.session_bookings"
        | "create.own.session_bookings"
        | "update.any.session_bookings"
        | "update.own.session_bookings"
        | "delete.any.session_bookings"
        | "delete.own.session_bookings"
        | "read.any.trial_blocks"
        | "read.own.trial_blocks"
        | "create.any.trial_blocks"
        | "create.own.trial_blocks"
        | "update.any.trial_blocks"
        | "update.own.trial_blocks"
        | "delete.any.trial_blocks"
        | "delete.own.trial_blocks"
        | "read.any.users"
        | "read.own.users"
        | "create.any.users"
        | "create.own.users"
        | "update.any.users"
        | "update.own.users"
        | "delete.any.users"
        | "delete.own.users"
        | "read.any.sessions"
        | "read.own.sessions"
        | "create.any.sessions"
        | "create.own.sessions"
        | "update.any.sessions"
        | "update.own.sessions"
        | "delete.any.sessions"
        | "delete.own.sessions"
        | "read.any.people"
        | "read.own.people"
        | "create.any.people"
        | "create.own.people"
        | "update.any.people"
        | "update.own.people"
        | "delete.any.people"
        | "read.any.driver_licence_records"
        | "create.any.driver_licence_records"
        | "update.any.driver_licence_records"
        | "delete.any.driver_licence_records"
        | "read.own.driver_licence_records"
        | "create.own.driver_licence_records"
        | "update.own.driver_licence_records"
        | "delete.own.driver_licence_records"
        | "read.any.payments"
        | "read.own.payments"
        | "create.any.payments"
        | "create.own.payments"
        | "update.any.payments"
        | "update.own.payments"
        | "delete.any.payments"
        | "delete.own.payments"
        | "read.any.invoices"
        | "read.own.invoices"
        | "create.any.invoices"
        | "create.own.invoices"
        | "update.any.invoices"
        | "update.own.invoices"
        | "delete.any.invoices"
        | "delete.own.invoices"
        | "read.any.amendments"
        | "read.own.amendments"
        | "create.any.amendments"
        | "create.own.amendments"
        | "update.any.amendments"
        | "update.own.amendments"
        | "delete.any.amendments"
        | "delete.own.amendments"
        | "read.any.conduct"
        | "read.own.conduct"
        | "create.any.conduct"
        | "create.own.conduct"
        | "update.any.conduct"
        | "update.own.conduct"
        | "delete.any.conduct"
        | "delete.own.conduct"
        | "read.any.diary_entries"
        | "read.own.diary_entries"
        | "create.any.diary_entries"
        | "create.own.diary_entries"
        | "update.any.diary_entries"
        | "update.own.diary_entries"
        | "delete.any.diary_entries"
        | "delete.own.diary_entries"
        | "read.any.vehicles"
      sex_enum: "Male" | "Female"
      shift_status: "Open" | "Filled" | "Cancelled" | "Unfulfilled"
      team_permission:
        | "view.tab.personal"
        | "view.tab.person_type"
        | "view.tab.accounts"
        | "view.tab.uniform"
        | "view.tab.diary"
        | "view.tab.documents"
        | "view.tab.finance"
        | "update.tab.personal"
        | "update.tab.person_type"
        | "update.tab.accounts"
        | "update.tab.uniform"
        | "update.tab.diary"
        | "update.tab.documents"
        | "update.tab.finance"
        | "view.tab.sheriff"
        | "update.tab.sheriff"
        | "view.page.vehicles"
        | "update.page.vehicles"
        | "view.page.incentives"
      ticket_webhook_status: "pending" | "sent" | "sent_without_details" | "error"
      timesheet_status: "InProgress" | "Pending" | "Approved" | "Denied"
      unavailability_status: "Pending" | "Approved" | "Denied" | "Cancelled"
      unavailability_type:
        "Holiday" | "Medical" | "Birthday" | "ReligiousObservance" | "PrivateMatter"
    }
    CompositeTypes: {
      vehicle_provider_upsert_row: {
        vehicle_id: string | null
        provider: string | null
        provider_reference: string | null
        provider_updated_at: string | null
        provider_metadata: Json | null
      }
    }
  }
}

type DatabaseWithoutInternals = Omit<Database, "__InternalSupabase">

type DefaultSchema = DatabaseWithoutInternals[Extract<keyof Database, "public">]

export type Tables<
  DefaultSchemaTableNameOrOptions extends
    | keyof (DefaultSchema["Tables"] & DefaultSchema["Views"])
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends (DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
        DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])
    : never) = never,
> = DefaultSchemaTableNameOrOptions extends { schema: keyof DatabaseWithoutInternals }
  ? (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
      DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])[TableName] extends {
      Row: infer R
    }
    ? R
    : never
  : DefaultSchemaTableNameOrOptions extends keyof (DefaultSchema["Tables"] & DefaultSchema["Views"])
    ? (DefaultSchema["Tables"] & DefaultSchema["Views"])[DefaultSchemaTableNameOrOptions] extends {
        Row: infer R
      }
      ? R
      : never
    : never

export type TablesInsert<
  DefaultSchemaTableNameOrOptions extends
    keyof DefaultSchema["Tables"] | { schema: keyof DatabaseWithoutInternals },
  TableName extends (DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never) = never,
> = DefaultSchemaTableNameOrOptions extends { schema: keyof DatabaseWithoutInternals }
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Insert: infer I
    }
    ? I
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
    ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
        Insert: infer I
      }
      ? I
      : never
    : never

export type TablesUpdate<
  DefaultSchemaTableNameOrOptions extends
    keyof DefaultSchema["Tables"] | { schema: keyof DatabaseWithoutInternals },
  TableName extends (DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never) = never,
> = DefaultSchemaTableNameOrOptions extends { schema: keyof DatabaseWithoutInternals }
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Update: infer U
    }
    ? U
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
    ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
        Update: infer U
      }
      ? U
      : never
    : never

export type Enums<
  DefaultSchemaEnumNameOrOptions extends
    keyof DefaultSchema["Enums"] | { schema: keyof DatabaseWithoutInternals },
  EnumName extends (DefaultSchemaEnumNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"]
    : never) = never,
> = DefaultSchemaEnumNameOrOptions extends { schema: keyof DatabaseWithoutInternals }
  ? DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"][EnumName]
  : DefaultSchemaEnumNameOrOptions extends keyof DefaultSchema["Enums"]
    ? DefaultSchema["Enums"][DefaultSchemaEnumNameOrOptions]
    : never

export type CompositeTypes<
  PublicCompositeTypeNameOrOptions extends
    keyof DefaultSchema["CompositeTypes"] | { schema: keyof DatabaseWithoutInternals },
  CompositeTypeName extends (PublicCompositeTypeNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"]
    : never) = never,
> = PublicCompositeTypeNameOrOptions extends { schema: keyof DatabaseWithoutInternals }
  ? DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"][CompositeTypeName]
  : PublicCompositeTypeNameOrOptions extends keyof DefaultSchema["CompositeTypes"]
    ? DefaultSchema["CompositeTypes"][PublicCompositeTypeNameOrOptions]
    : never

export const Constants = {
  graphql_public: {
    Enums: {},
  },
  public: {
    Enums: {
      app_role: ["Admin", "Manager", "Driver", "DSP"],
      app_team: [
        "Central Operations",
        "Driver Operations",
        "Customer Service",
        "Fleet",
        "Depot",
        "Revenue Protection",
        "Finance",
        "Admin",
        "DSP Manager",
      ],
      cancelled_reason: [
        "Sickness",
        "FamilyEmergency",
        "OtherWorkCommitments",
        "HivedCapacity",
        "RetailerRequest",
        "Offboarded",
        "RequestedByDriver",
        "RequestedByDsp",
        "UnavailabilityRequest",
        "MovedPosition",
        "Onboarded",
        "SheriffTypeChanged",
      ],
      pay_basis: ["Hourly", "Daily", "Monthly"],
      pay_group: ["Fortnightly", "Monthly"],
      payment_basis: ["Route-based", "Hourly-based", "Salary"],
      person_areas: [
        "Rc1 Deliveries",
        "Rc2 Deliveries",
        "Collections",
        "Fleet Team",
        "Sortation",
        "Depot",
        "Network",
        "Live Ops",
        "Customer Service",
        "Driver Ops",
        "Driver Partnerships",
        "Driver Resourcing",
        "Dsp Managers",
        "Cx",
        "Des",
        "Hq",
      ],
      person_employer: ["HIVED", "Self Employed", "DSP", "Agency", "Not Employed"],
      person_role: [
        "HIVED Partner Driver",
        "HIVED Partner Driver (PM)",
        "DSP",
        "Agency Driver",
        "Collection Driver",
        "Sortation",
        "Agency Sortation",
        "HQ",
      ],
      person_status: ["Applicant", "Trial", "Active", "Inactive"],
      person_type: [
        "HivedVan",
        "HivedHgv",
        "HivedFlex",
        "TakeHomeVan",
        "Dsp",
        "Trial",
        "Internal",
        "Flex",
        "AssociateDriver",
      ],
      role_permission: [
        "create.own.applications",
        "create.any.applications",
        "update.own.applications",
        "update.any.applications",
        "read.own.applications",
        "read.any.applications",
        "delete.any.applications",
        "delete.own.applications",
        "read.any.anonymous_visitors",
        "read.own.anonymous_visitors",
        "create.any.anonymous_visitors",
        "create.own.anonymous_visitors",
        "update.any.anonymous_visitors",
        "update.own.anonymous_visitors",
        "delete.any.anonymous_visitors",
        "delete.own.anonymous_visitors",
        "read.any.depots",
        "read.own.depots",
        "create.any.depots",
        "create.own.depots",
        "update.any.depots",
        "update.own.depots",
        "delete.any.depots",
        "delete.own.depots",
        "read.any.action_costs",
        "read.own.action_costs",
        "create.any.action_costs",
        "create.own.action_costs",
        "update.any.action_costs",
        "update.own.action_costs",
        "delete.any.action_costs",
        "delete.own.action_costs",
        "read.any.jobs",
        "read.own.jobs",
        "create.any.jobs",
        "create.own.jobs",
        "update.any.jobs",
        "update.own.jobs",
        "delete.any.jobs",
        "delete.own.jobs",
        "read.any.team_permissions",
        "read.own.team_permissions",
        "create.any.team_permissions",
        "create.own.team_permissions",
        "update.any.team_permissions",
        "update.own.team_permissions",
        "delete.any.team_permissions",
        "delete.own.team_permissions",
        "read.any.role_permissions",
        "read.own.role_permissions",
        "create.any.role_permissions",
        "create.own.role_permissions",
        "update.any.role_permissions",
        "update.own.role_permissions",
        "delete.any.role_permissions",
        "delete.own.role_permissions",
        "read.any.application_stage_history",
        "read.own.application_stage_history",
        "create.any.application_stage_history",
        "create.own.application_stage_history",
        "update.any.application_stage_history",
        "update.own.application_stage_history",
        "delete.any.application_stage_history",
        "delete.own.application_stage_history",
        "read.any.driver_dvla_checks",
        "read.own.driver_dvla_checks",
        "create.any.driver_dvla_checks",
        "create.own.driver_dvla_checks",
        "update.any.driver_dvla_checks",
        "update.own.driver_dvla_checks",
        "delete.any.driver_dvla_checks",
        "delete.own.driver_dvla_checks",
        "read.any.shifts",
        "read.own.shifts",
        "create.any.shifts",
        "create.own.shifts",
        "update.any.shifts",
        "update.own.shifts",
        "delete.any.shifts",
        "delete.own.shifts",
        "read.any.timesheets",
        "read.own.timesheets",
        "create.any.timesheets",
        "create.own.timesheets",
        "update.any.timesheets",
        "update.own.timesheets",
        "delete.any.timesheets",
        "delete.own.timesheets",
        "read.any.assessments",
        "read.own.assessments",
        "create.any.assessments",
        "create.own.assessments",
        "update.any.assessments",
        "update.own.assessments",
        "delete.any.assessments",
        "delete.own.assessments",
        "read.any.comments",
        "read.own.comments",
        "create.any.comments",
        "create.own.comments",
        "update.any.comments",
        "update.own.comments",
        "delete.any.comments",
        "delete.own.comments",
        "read.any.unavailability",
        "read.own.unavailability",
        "create.any.unavailability",
        "create.own.unavailability",
        "update.any.unavailability",
        "update.own.unavailability",
        "delete.any.unavailability",
        "delete.own.unavailability",
        "read.any.auth_session_cache",
        "read.own.auth_session_cache",
        "create.any.auth_session_cache",
        "create.own.auth_session_cache",
        "update.any.auth_session_cache",
        "update.own.auth_session_cache",
        "delete.any.auth_session_cache",
        "delete.own.auth_session_cache",
        "read.any.applicants",
        "read.own.applicants",
        "create.any.applicants",
        "create.own.applicants",
        "update.any.applicants",
        "update.own.applicants",
        "delete.any.applicants",
        "delete.own.applicants",
        "read.any.documents",
        "read.own.documents",
        "create.any.documents",
        "create.own.documents",
        "update.any.documents",
        "update.own.documents",
        "delete.any.documents",
        "delete.own.documents",
        "read.any.session_bookings",
        "read.own.session_bookings",
        "create.any.session_bookings",
        "create.own.session_bookings",
        "update.any.session_bookings",
        "update.own.session_bookings",
        "delete.any.session_bookings",
        "delete.own.session_bookings",
        "read.any.trial_blocks",
        "read.own.trial_blocks",
        "create.any.trial_blocks",
        "create.own.trial_blocks",
        "update.any.trial_blocks",
        "update.own.trial_blocks",
        "delete.any.trial_blocks",
        "delete.own.trial_blocks",
        "read.any.users",
        "read.own.users",
        "create.any.users",
        "create.own.users",
        "update.any.users",
        "update.own.users",
        "delete.any.users",
        "delete.own.users",
        "read.any.sessions",
        "read.own.sessions",
        "create.any.sessions",
        "create.own.sessions",
        "update.any.sessions",
        "update.own.sessions",
        "delete.any.sessions",
        "delete.own.sessions",
        "read.any.people",
        "read.own.people",
        "create.any.people",
        "create.own.people",
        "update.any.people",
        "update.own.people",
        "delete.any.people",
        "read.any.driver_licence_records",
        "create.any.driver_licence_records",
        "update.any.driver_licence_records",
        "delete.any.driver_licence_records",
        "read.own.driver_licence_records",
        "create.own.driver_licence_records",
        "update.own.driver_licence_records",
        "delete.own.driver_licence_records",
        "read.any.payments",
        "read.own.payments",
        "create.any.payments",
        "create.own.payments",
        "update.any.payments",
        "update.own.payments",
        "delete.any.payments",
        "delete.own.payments",
        "read.any.invoices",
        "read.own.invoices",
        "create.any.invoices",
        "create.own.invoices",
        "update.any.invoices",
        "update.own.invoices",
        "delete.any.invoices",
        "delete.own.invoices",
        "read.any.amendments",
        "read.own.amendments",
        "create.any.amendments",
        "create.own.amendments",
        "update.any.amendments",
        "update.own.amendments",
        "delete.any.amendments",
        "delete.own.amendments",
        "read.any.conduct",
        "read.own.conduct",
        "create.any.conduct",
        "create.own.conduct",
        "update.any.conduct",
        "update.own.conduct",
        "delete.any.conduct",
        "delete.own.conduct",
        "read.any.diary_entries",
        "read.own.diary_entries",
        "create.any.diary_entries",
        "create.own.diary_entries",
        "update.any.diary_entries",
        "update.own.diary_entries",
        "delete.any.diary_entries",
        "delete.own.diary_entries",
        "read.any.vehicles",
      ],
      sex_enum: ["Male", "Female"],
      shift_status: ["Open", "Filled", "Cancelled", "Unfulfilled"],
      team_permission: [
        "view.tab.personal",
        "view.tab.person_type",
        "view.tab.accounts",
        "view.tab.uniform",
        "view.tab.diary",
        "view.tab.documents",
        "view.tab.finance",
        "update.tab.personal",
        "update.tab.person_type",
        "update.tab.accounts",
        "update.tab.uniform",
        "update.tab.diary",
        "update.tab.documents",
        "update.tab.finance",
        "view.tab.sheriff",
        "update.tab.sheriff",
        "view.page.vehicles",
        "update.page.vehicles",
        "view.page.incentives",
      ],
      ticket_webhook_status: ["pending", "sent", "sent_without_details", "error"],
      timesheet_status: ["InProgress", "Pending", "Approved", "Denied"],
      unavailability_status: ["Pending", "Approved", "Denied", "Cancelled"],
      unavailability_type: [
        "Holiday",
        "Medical",
        "Birthday",
        "ReligiousObservance",
        "PrivateMatter",
      ],
    },
  },
} as const
